import quick_resume_apply_widget_0 from "file:///home/wldocker/wl-cms/sites/modules/quick-resume-apply-widget/ui/src/quick-resume-apply-widget.js";



import quick_resume_apply_widget_0Stylesheet from "file:///home/wldocker/wl-cms/sites/modules/quick-resume-apply-widget/ui/src/quick-resume-apply-widget.scss";quick_resume_apply_widget_0();